<template>
    <div class="dashboard-container">
        <!-- Header Section -->
        <div class="dashboard-header mb-3">
            <v-card class="header-card gradient-primary" flat>
                <v-card-title class="pa-6">
                    <div class="header-content">
                        <div class="header-left">
                            <v-avatar size="32" color="white" class="mr-4">
                                <v-icon color="primary" size="24">mdi-receipt-text</v-icon>
                            </v-avatar>
                            <div>
                                <h1 class="text-h4 font-weight-bold white--text mb-1">
                                    Control de Envios
                                </h1>
                                <p class="text-subtitle1 white--text opacity-80 mb-0">
                                    Gestión y confirmación de recibos de pagos
                                </p>
                            </div>
                        </div>
                        <div class="header-right">
                            <v-text-field v-model="filter.Search" @keydown.enter="loadData()" @blur="loadData()"
                                placeholder="Buscar recibos..." prepend-inner-icon="mdi-magnify" outlined dense
                                hide-details class="search-field-header" clearable dark color="white">
                                <template v-slot:append-outer>
                                    <v-btn @click="loadData()" color="white" text icon class="ml-2">
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </div>
                    </div>
                </v-card-title>
            </v-card>
        </div>

        <!-- Statistics Cards -->
        <div class="stats-row mb-3">
            <!-- <v-col cols="12" sm="6" md="3" lg="2"> -->
            <v-card class="stats-card stats-card-primary" elevation="0" flat>
                <v-card-text class="px-4 py-2">
                    <div class="stats-content">
                        <div class="stats-icon-wrapper primary-icon">
                            <v-icon color="primary" size="20">mdi-file-document-multiple</v-icon>
                        </div>
                        <p class="stats-label mb-1">Total Cargadas</p>
                        <h3 class="stats-value">{{ statistics.RecordTotal }}</h3>
                    </div>
                </v-card-text>
            </v-card>
            <!-- </v-col> -->

            <!-- <v-col cols="12" sm="6" md="3" lg="2"> -->
            <v-card class="stats-card stats-card-success" elevation="0" flat>
                <v-card-text class="px-4 py-2">
                    <div class="stats-content">
                        <div class="stats-icon-wrapper success-icon">
                            <v-icon color="success" size="20">mdi-check-circle</v-icon>
                        </div>
                        <p class="stats-label mb-1">Confirmados</p>
                        <h3 class="stats-value">{{ statistics.ConfirmedCount }}</h3>
                    </div>
                </v-card-text>
            </v-card>
            <!-- </v-col> -->

            <!-- <v-col cols="12" sm="6" md="3" lg="2"> -->
            <v-card class="stats-card stats-card-warning" elevation="0" flat>
                <v-card-text class="px-4 py-2">
                    <div class="stats-content">
                        <div class="stats-icon-wrapper warning-icon">
                            <v-icon color="warning" size="20">mdi-clock-outline</v-icon>
                        </div>
                        <p class="stats-label mb-1">Pendientes</p>
                        <h3 class="stats-value">{{ statistics.PendingCount }}</h3>
                    </div>
                </v-card-text>
            </v-card>
            <!-- </v-col> -->

            <!-- <v-col cols="12" sm="6" md="3" lg="2"> -->
            <v-card class="stats-card stats-card-info" elevation="0" flat>
                <v-card-text class="px-4 py-2">
                    <div class="stats-content">
                        <div class="stats-icon-wrapper info-icon">
                            <v-icon color="info" size="20">mdi-chart-line</v-icon>
                        </div>
                        <p class="stats-label mb-1">Tasa Confirmación</p>
                        <h3 class="stats-value">{{ statistics.ConfirmationRate }}%</h3>
                    </div>
                </v-card-text>
            </v-card>
            <!-- </v-col> -->

            <!-- <v-col cols="12" sm="6" md="3" lg="2"> -->
            <v-card class="stats-card stats-card-primary" elevation="0" flat>
                <v-card-text class="px-4 py-2">
                    <div class="stats-content">
                        <div class="stats-icon-wrapper primary-icon">
                            <v-icon color="error" size="20">mdi-human-handsup</v-icon>
                        </div>
                        <p class="stats-label mb-1">Boletas Personal Baja</p>
                        <h3 class="stats-value">{{ statistics.EmployeeDown }}</h3>
                    </div>
                </v-card-text>
            </v-card>
            <!-- </v-col> -->
        </div>

        <!-- Filters Section -->
        <v-card class="filter-card mb-3" elevation="2">
            <v-card-title class="pa-4">
                <v-icon class="mr-3" color="primary">mdi-filter-variant</v-icon>
                <span class="text-h6 font-weight-medium">Filtros de Búsqueda</span>
                <v-spacer></v-spacer>
                <v-btn @click="clearFilters" color="grey" text small class="mr-2">
                    <v-icon small left>mdi-filter-off</v-icon>
                    Limpiar Filtros
                </v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pa-4">
                <v-row align="end" dense>
                    <v-col cols="12" md="4" lg="3">
                        <s-select-area label="Área" v-model="filter.SearchAreaID" outlined dense hide-details full
                            noDefault prepend-inner-icon="mdi-domain" clearable />
                    </v-col>

                    <v-col cols="12" md="2">
                        <s-select-definition label="Estado de Confirmación" :def="1591" v-model="filter.StatusReceived"
                            @change="loadData()" outlined dense hide-details clearable
                            prepend-inner-icon="mdi-check-circle-outline" />
                    </v-col>

                    <v-col cols="12" md="2">
                        <s-select-definition label="Turno" :def="1062" v-model="filter.TypeTurno" outlined dense
                            hide-details clearable @change="loadData()" />
                    </v-col>

                    <v-col cols="12" md="2">
                        <s-select label="Cuadrilla" :items="quadrille" autocomplete item-text="GngName"
                            item-value="GngID" v-model="filter.GngID" clearable @change="loadData()"></s-select>
                    </v-col>

                    <v-col cols="12" md="4" lg="3">
                        <s-select-definition :def="1060" v-model="TypePayrollIds" label="Tipo Planilla" clearable
                            @change="loadData()" multiple />
                    </v-col>

                    <v-col cols="12" md="2">
                        <s-select label="Año" :items="years" autocomplete item-text="PspYear" item-value="PspYear"
                            v-model="filter.PspYear" clearable @change="loadData" />
                    </v-col>

                    <v-col cols="12" md="2">
                        <s-select label="Mes" :items="months" autocomplete item-text="PspMonth" item-value="PspMonth"
                            v-model="filter.PspMonth" clearable @change="loadData" />
                    </v-col>

                    <v-col cols="12" md="2">
                        <s-select label="Semana" :items="weeks" item-text="PspWeek" item-value="PspWeek"
                            v-model="filter.PspWeek" clearable @change="loadData" />
                    </v-col>

                    <v-col cols="12" md="2">
                        <s-select label="Tipo Documento" :items="typeDocuments" item-text="PspTypeDescription"
                            item-value="PspTypeName" v-model="filter.PspTypeName" clearable
                            @change="loadData()"></s-select>
                    </v-col>

                    <v-col cols="12" md="4" lg="3">
                        <v-menu offset-y transition="scale-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="success" :loading="loading || exporting" elevation="2" v-bind="attrs"
                                    v-on="on" class="px-6">
                                    <v-icon left>mdi-microsoft-excel</v-icon>
                                    Exportar
                                    <v-icon right size="18">mdi-chevron-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item @click="exportToExcel">
                                    <v-list-item-icon class="mr-3">
                                        <v-icon small color="success">mdi-file-excel</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Detallado</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click="exportToExcelConsolidated">
                                    <v-list-item-icon class="mr-3">
                                        <v-icon small color="success">mdi-table-headers-eye</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Consolidado</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- Results Section -->
        <v-card class="results-card" elevation="2">
            <v-card-title class="pa-4 pb-2">
                <v-icon class="mr-3" color="primary">mdi-table</v-icon>
                <span class="text-h6 font-weight-medium">Resultados</span>
                <v-spacer></v-spacer>
                <v-chip v-if="recordsTotal > 0" color="primary" text-color="white" small class="elevation-1">
                    <v-icon small left>mdi-database</v-icon>
                    {{ recordsTotal }} registro{{ recordsTotal !== 1 ? 's' : '' }}
                </v-chip>
            </v-card-title>

            <v-divider></v-divider>

            <v-data-table :headers="headers" :loading="loading" :items="items" item-key="PspID" v-model="selected"
                @click:row="selectedCheckSlot($event)" :items-per-page="25" class="modern-data-table" :footer-props="{
                    showCurrentPage: true,
                    showFirstLastPage: true,
                    itemsPerPageOptions: [25, 50, 100, -1],
                }" no-data-text="No se encontraron registros" loading-text="Cargando datos..." elevation="0"
                :server-items-length="recordsTotal" :options.sync="options" @update:options="onOptionsChange">
                <!-- Row Number -->
                <template v-slot:item.rowNumber="{ index }">
                    <v-chip small color="grey lighten-3" text-color="grey darken-2">
                        {{ index + 1 }}
                    </v-chip>
                </template>

                <!-- Full Name with Avatar -->
                <template v-slot:item.PspFullName="{ item }">
                    <div class="name-cell d-flex align-center">
                        <!-- <v-avatar size="24" color="primary lighten-4" class="mr-3">
                            <v-icon color="primary" size="4">mdi-account</v-icon>
                        </v-avatar> -->
                        <div>
                            <span class="font-weight-medium">{{ item.PspFullName }}</span>
                        </div>
                    </div>
                </template>

                <!-- DNI with styling -->
                <template v-slot:item.PspUserDNI="{ item }">
                    <v-chip small color="grey lighten-4" text-color="grey darken-3"
                        class="dni-chip font-mono primary--text">
                        <v-icon x-small size="4" left>mdi-card-account-details</v-icon>
                        {{ item.PspUserDNI }}
                    </v-chip>
                </template>

                <!-- Received Date with Status -->
                <template v-slot:item.PspDateReceived="{ item }">
                    <div v-if="item.PspDateReceived" class="status-cell">
                        <div class="d-flex align-center">
                            <!-- <v-icon small color="success" class="mr-1">mdi-calendar-check</v-icon> -->
                            <span class="date-text">{{ $fun.formatDateTimeView(item.PspDateReceived) }}</span>
                        </div>
                        <v-chip x-small color="success" text-color="white" class="status-chip">
                            <!-- <v-icon x-small left>mdi-check-circle</v-icon> -->
                            CONFIRMADO
                        </v-chip>
                    </div>
                    <div v-else class="status-cell">
                        <v-chip x-small color="warning" text-color="white" class="status-chip">
                            <!-- <v-icon x-small left>mdi-clock</v-icon> -->
                            PENDIENTE
                        </v-chip>
                    </div>
                </template>

                <template v-slot:item.CtrStatus="{ item }">
                    <v-chip x-small :color="item.CtrStatus == 2 ? 'error' : 'success'" text-color="white"
                        class="status-chip">
                        {{ item.CtrStatus == 2 ? 'INACTIVO' : 'ACTIVO' }}
                    </v-chip>
                </template>

                <!-- Creation Date -->
                <template v-slot:item.SecCreate="{ item }">
                    <div v-if="item.SecCreate" class="date-cell text-center">
                        <!-- <v-icon small color="grey" class="mr-1">mdi-calendar</v-icon> -->
                        <span class="date-text">{{ $fun.formatDateTimeView(item.SecCreate) }}</span>
                    </div>
                    <div v-else class="no-date-cell text-center">
                        <v-icon small color="grey lighten-1" class="mr-1">mdi-calendar-remove</v-icon>
                        <span class="grey--text">Sin registro</span>
                    </div>
                </template>

                <!-- Actions Column -->
                <template v-slot:item.actions="{ item }">
                    <div class="action-buttons">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small color="primary" v-bind="attrs" v-on="on"
                                    @click.stop="viewDetails(item)">
                                    <v-icon small>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Ver detalles</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small color="success" v-bind="attrs" v-on="on"
                                    @click.stop="confirmReceipt(item)" :disabled="!!item.PspDateReceived">
                                    <v-icon small>mdi-check</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ item.PspDateReceived ? 'Ya confirmado' : 'Confirmar recibo' }}</span>
                        </v-tooltip>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>

import _HmnReportPaySlipConfirmService from '../../../services/HumanResource/AriSunshine/HmnReportPaySlipConfirmService';
import { exportVuetifyToExcel } from '@/utils/excelExport';
import _sQuadriService from "@/services/HumanResource/hmnGang.js";
import { DateTime } from "luxon";

export default {
    data() {
        return {
            TypePayrollIds: [],
            headers: [
                {
                    text: 'Área',
                    value: 'AreName',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Cargo',
                    value: 'PstName',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Planilla',
                    value: 'TypePayrollName',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Semana',
                    value: 'PspWeek',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Nombre y Apellido',
                    value: 'PspFullName',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'DNI',
                    value: 'PspUserDNI',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Turno',
                    value: 'TypeTurnoName',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Cuadrilla',
                    value: 'CrewName',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Estado',
                    value: 'PspDateReceived',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Fecha de Creación',
                    value: 'SecCreate',
                    sortable: true,
                    class: 'header-text'
                },
                {
                    text: 'Tipo Documento',
                    value: 'PspTypeDescription',
                    sortable: true,
                    align: 'center',
                    class: 'header-text'
                },
                {
                    text: 'Estado Trabajador',
                    value: 'CtrStatus',
                    sortable: true,
                    align: 'center',
                    class: 'header-text'
                }
            ],
            items: [],
            statistics: {},
            selected: [],
            totalItems: 0,
            countItems: 0,
            loading: false,
            exporting: false,
            dataFromBackend: [],
            years: [],
            months: [],
            weeks: [],
            typeDocuments: [],
            filter: {
                Search: null,
                StatusReceived: 1,
                SearchAreaID: null,
                PspYear: DateTime.now().year,
                PspMonth: null,
                PspWeek: null,
                PspTypeName: null,
                TypePayroll: null,
                TypePayrollIds: ""
            },
            pagination: {
                draw: 1,
                start: 0,
                length: 25,
                order: [{ dir: "asc", column: "" }],
                searchText: "",
            },
            options: {
                page: 1,
                itemsPerPage: 25,
                sortBy: [],
                sortDesc: [],
            },
            quadrille: [],
            recordsTotal: 0
        }
    },
    created() {
        this.loadData();
        this.getQuadrille();
        // this.getFilters();
        this.getTypedocuments();
    },
    methods: {
        getTypedocuments() {
            _HmnReportPaySlipConfirmService.typedocuments(this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                    // console.log({ typeDocuments: resp.data });
                    this.typeDocuments = resp.data;
                }
            });
        },
        getQuadrille() {
            let obj = {
                SecStatus: 1,
            };
            _sQuadriService.list(obj, this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                    // console.log(resp.data);
                    this.quadrille = resp.data;
                }
            });
        },
        onOptionsChange(newOptions) {
            this.options = newOptions;

            // Convertir opciones de Vuetify → DataTables backend
            this.pagination.start = (newOptions.page - 1) * newOptions.itemsPerPage;
            this.pagination.length = newOptions.itemsPerPage;

            if (newOptions.sortBy.length > 0) {
                this.pagination.order = [{
                    column: newOptions.sortBy[0],
                    dir: newOptions.sortDesc[0] ? "desc" : "asc"
                }];
            }

            this.loadData(); // Recargar con la nueva paginación
        },
        async loadData() {
            this.loading = true;

            try {
                const TypePayrollIds = this.parseStringToArrayOrNull().length > 0 ? this.TypePayrollIds : null;
                const filter = { ...this.filter, TypePayrollIds, PspYear: this.years.includes(this.filter.PspYear) ? this.filter.PspYear : null }
                const response = await _HmnReportPaySlipConfirmService.pagination({ ...this.pagination, filter }, this.$fun.getUserID());
                const { data } = response;
                this.recordsTotal = data.DataTable.recordsTotal;
                this.items = data.DataTable.data;
                this.statistics = data.Statistics;

                const yearMatch = (item) => !this.filter.PspYear || item.PspYear == this.filter.PspYear;
                const monthMatch = (item) => !this.filter.PspMonth || item.PspMonth == this.filter.PspMonth;

                this.years = [...new Set(data.Filters.map(i => i.PspYear))];
                this.months = [...new Set(data.Filters.filter(yearMatch).map(i => i.PspMonth))];

                // Weeks logic: Filter by Year, then by Month if it exists
                let weeksData = data.Filters.filter(yearMatch);
                if (this.filter.PspMonth) {
                    weeksData = weeksData.filter(monthMatch);
                }
                this.weeks = [...new Set(weeksData.map(i => i.PspWeek))].filter(w => w).sort();
            } catch (error) {
                console.error(error);
                this.$toast.error('Error al cargar los datos');
            } finally {
                this.loading = false;
            }
        },
        parseStringToArrayOrNull() {
            if (!this.TypePayrollIds) return [];
            try {
                const arr = JSON.parse(this.TypePayrollIds);
                return Array.isArray(arr) ? arr : [];
            } catch (e) {
                return [];
            }
        },
        async exportToExcel() {
            this.exporting = true;
            try {
                const TypePayrollIds = this.parseStringToArrayOrNull().length > 0 ? this.TypePayrollIds : null;
                const filter = { ...this.filter, TypePayrollIds, PspYear: this.years.includes(this.filter.PspYear) ? this.filter.PspYear : null }
                const newPagination = { ...this.pagination, length: -1, filter }
                const response = await _HmnReportPaySlipConfirmService.pagination(newPagination, this.$fun.getUserID());
                const { data } = response;

                // Reemplazo el key de CtrStatus por CtrStatusName
                const headersExcel = this.headers.map(h => {
                    if (h.value == 'CtrStatus') {
                        h.value = 'CtrStatusName'
                    }
                    return h;
                });

                await exportVuetifyToExcel(
                    headersExcel,
                    data.DataTable.data,
                    {
                        title: 'Reporte Boletas de Pagos del Personal',
                        subtitle: `Generado el ${this.$fun.getDateTimeShortDB()}`,
                        filename: `Reporte_boletas_pago_personal ${this.$fun.getDateTimeShortDB()}`,
                    }
                );
            } catch (error) {
                this.exporting = false;
                console.error('Error al exportar a Excel:', error);
            } finally {
                this.exporting = false;
            }
        },
        async exportToExcelConsolidated() {
            this.exporting = true;
            try {
                const TypePayrollIds = this.parseStringToArrayOrNull().length > 0 ? this.TypePayrollIds : null;
                const filter = { ...this.filter, TypePayrollIds, PspYear: this.years.includes(this.filter.PspYear) ? this.filter.PspYear : null }
                const newPagination = { ...this.pagination, length: -1, filter }
                const response = await _HmnReportPaySlipConfirmService.pagination(newPagination, this.$fun.getUserID());
                const { data } = response;
                const headers = [
                    { text: 'MES', value: 'PspWeek', class: 'header-text' },
                    { text: 'N° BOLETAS', value: 'RecordTotal', class: 'header-text' },
                    { text: 'SI', value: 'ConfirmedCount', class: 'header-text' },
                    { text: 'NO', value: 'PendingCount', class: 'header-text' },
                    { text: '%', value: 'ConfirmationRate', class: 'header-text' },
                    { text: 'PERSONAL BOLETAS BAJA', value: 'EmployeeDown', class: 'header-text' }
                ];
                // console.log(data.Consolidated)
                await exportVuetifyToExcel(
                    headers,
                    data.Consolidated,
                    {
                        title: 'Consolidado de Boletas de Pagos del Personal',
                        subtitle: `Generado el ${this.$fun.getDateTimeShortDB()}`,
                        filename: `Consolidado_boletas_pago_personal ${this.$fun.getDateTimeShortDB()}`,
                    }
                );
            } catch (error) {
                this.exporting = false;
                console.error('Error al exportar a Excel:', error);
            } finally {
                this.exporting = false;
            }
        },
        selectedCheckSlot(value) {
            this.selected = [value];
        },
        clearFilters() {
            this.filter = {
                Search: null,
                StatusReceived: null,
                SearchAreaID: null,
                PspYear: DateTime.now().year,
                PspMonth: null,
                PspWeek: null,
                PspTypeName: null,
                TypePayroll: null,
                TypePayrollIds: ""
            };
            this.TypePayrollIds = [];
            this.loadData();
        },
        viewDetails(item) {
            // Implementar lógica para ver detalles
            console.log('Ver detalles:', item);
        },
        confirmReceipt(item) {
            // Implementar lógica para confirmar recibo
            console.log('Confirmar recibo:', item);
        },
        getFilters() {
            _HmnReportPaySlipConfirmService.list(this.filter, this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                    this.dataFromBackend = resp.data;
                }
            })
        }
    },
    watch: {
        'TypePayrollIds': function (newValue) {
            this.loadData();
        },
        'filter.SearchAreaID': function (newValue) {
            this.loadData();
        },
        'filter.PspYear'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.filter.PspMonth = null
                this.filter.PspWeek = null
            }
        },
        'filter.PspMonth'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.filter.PspWeek = null
            }
        }
    },
}
</script>

<style scoped>
.dashboard-container {
    padding: 12px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.gradient-primary {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    border-radius: 16px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-left {
    display: flex;
    align-items: center;
}

.header-right {
    display: flex;
    justify-items: center;
    align-items: center !important;
    min-width: 300px;
}

.search-field-header {
    padding-left: 8px;
    flex-shrink: 1;
    align-items: center !important;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
}

.search-field-header>>>.v-input__slot {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

.stats-row {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
}

.stats-row .v-col {
    padding: 8px;
}

.stats-card {
    border-radius: 12px;
    transition: all 0.3s ease;
    border-left: 4px solid transparent;
}

.stats-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.stats-card:nth-child(1) {
    border-left-color: var(--v-primary-base);
}

.stats-card:nth-child(2) {
    border-left-color: var(--v-success-base);
}

.stats-card:nth-child(3) {
    border-left-color: var(--v-warning-base);
}

.stats-card:nth-child(4) {
    border-left-color: var(--v-info-base);
}

.filter-card,
.results-card {
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.modern-data-table {
    border-radius: 0 0 12px 12px;
}

.modern-data-table>>>.v-data-table__wrapper {
    border-radius: 0 0 12px 12px;
}

.modern-data-table>>>tbody tr:hover {
    background-color: rgba(103, 126, 234, 0.04) !important;
}

.modern-data-table>>>thead tr th {
    background-color: #fafbfc;
    font-weight: 600;
    color: #2c3e50;
    border-bottom: 2px solid #e9ecef;
}

.date-cell,
.status-cell {
    padding: 4px 0;
}

.date-text {
    font-size: 0.875rem;
    color: #495057;
}

.name-cell {
    padding: 8px 0;
}

.dni-chip {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    letter-spacing: 0.5px;
}

.status-chip {
    font-size: 0.75rem;
    font-weight: 600;
    padding: 8px 6px !important;
}

.action-buttons {
    display: flex;
    gap: 4px;
    justify-content: center;
}

.opacity-80 {
    opacity: 0.8;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .stats-row {
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }
}

@media (max-width: 960px) {
    .dashboard-container {
        padding: 8px;
    }

    .header-content {
        flex-direction: column;
        gap: 16px;
    }

    .header-right {
        min-width: 100%;
    }

    .stats-row .v-col {
        padding: 4px;
    }

    .stats-row {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
}

@media (max-width: 600px) {
    .dashboard-container {
        padding: 12px;
    }

    .name-cell .v-avatar {
        display: none;
    }

    .stats-row {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
}
</style>